// Date 2021-03-19 18:16:53

import sithMesInventoryAreaLoc from "@/store/sithMes/inventory/SithMesInventoryAreaLocStore.js";
import sithMesInventoryReceiveErrorType from "@/store/sithMes/inventory/SithMesInventoryReceiveErrorTypeStore.js";
import sithMesInventoryStatus from "@/store/sithMes/inventory/SithMesInventoryStatusStore.js";
import sithMesInventoryItem from "@/store/sithMes/inventory/SithMesInventoryItemStore.js";
import sithMesInventoryPackingBom from "@/store/sithMes/inventory/SithMesInventoryPackingBomStore.js";
import sithMesInventoryPo from "@/store/sithMes/inventory/SithMesInventoryPoStore.js";
import sithMesInventoryAbnormalArrivalProcess
    from "@/store/sithMes/inventory/SithMesInventoryAbnormalArrivalProcessStore.js";
import sithMesInventoryDeliveryTask from "@/store/sithMes/inventory/SithMesInventoryDeliveryTaskStore.js";
import sithMesInventoryDeliveryMaterial from "@/store/sithMes/inventory/SithMesInventoryDeliveryMaterialStore.js";
import sithMesInventoryPackage from "@/store/sithMes/inventory/SithMesInventoryPackageStore.js";
import sithMesInventoryShipment from "@/store/sithMes/inventory/SithMesInventoryShipmentStore.js";
import sithMesInventoryPackageMaterial from "@/store/sithMes/inventory/SithMesInventoryPackageMaterialStore.js";
import sithMesInventoryWmStock from "@/store/sithMes/inventory/SithMesInventoryWmStockStore.js";
import sithMesInventoryWmDefinition from "@/store/sithMes/inventory/SithMesInventoryWmDefinitionStore.js";
import sithMesInventoryBinStatus from "@/store/sithMes/inventory/SithMesInventoryBinStatusStore.js";
import sithMesInventoryStorageInput from "@/store/sithMes/inventory/SithMesInventoryStorageInputStore.js";
import sithMesInventoryMaterialDispatching from "@/store/sithMes/inventory/SithMesInventoryMaterialDispatchingStore.js";
import sithMesInventoryReplacementRepair from "@/store/sithMes/inventory/SithMesInventoryReplacementRepairStore.js";
import sithMesInventoryCount from "@/store/sithMes/inventory/SithMesInventoryCountStore.js";
import sithMesInventoryChangeMaterialProject
    from "@/store/sithMes/inventory/SithMesInventoryChangeMaterialProjectStore.js";
import sithMesInventoryTransportApplication
    from "@/store/sithMes/inventory/SithMesInventoryTransportApplicationStore.js";
import sithMesInventoryReceiptReturnRecord from "@/store/sithMes/inventory/SithMesInventoryReceiptReturnRecordStore.js";
import sithMesInventoryOutdoorProcess from "@/store/sithMes/inventory/SithMesInventoryOutdoorProcessStore.js";
import sithMesInventoryOutdoorProductDetail
    from "@/store/sithMes/inventory/SithMesInventoryOutdoorProductDetailStore.js";
import sithMesInventoryOutdoorProductCategory
    from "@/store/sithMes/inventory/SithMesInventoryOutdoorProductCategoryStore.js";
import sithMesInventoryStockReturn from "@/store/sithMes/inventory/SithMesInventoryStockReturnStore.js";
import sithMesInventoryStockMovement from "@/store/sithMes/inventory/SithMesInventoryStockMovementStore.js";
import sithMesInventoryChangeProjectDetail from "@/store/sithMes/inventory/SithMesInventoryChangeProjectDetailStore.js";
import sithMesInventoryManualStorageType from "@/store/sithMes/inventory/SithMesInventoryManualStorageTypeStore.js";
import sithMesInventoryManualMaterialType from "@/store/sithMes/inventory/SithMesInventoryManualMaterialTypeStore.js";
import sithMesInventoryManualCheck from "@/store/sithMes/inventory/SithMesInventoryManualCheckStore.js";
import sithMesInventoryManualInput from "@/store/sithMes/inventory/SithMesInventoryManualInputStore.js";
import sithMesInventoryManualOutput from "@/store/sithMes/inventory/SithMesInventoryManualOutputStore.js";
import sithMesInventoryLiftCheck from "@/store/sithMes/inventory/SithMesInventoryLiftCheckStore.js";
import sithMesInventoryLiftRiggings from "@/store/sithMes/inventory/SithMesInventoryLiftRiggingsStore.js";
import sithMesInventoryComprehensiveBusinessRecord from "@/store/sithMes/inventory/SithMesInventoryComprehensiveBusinessRecordStore.js";
import sithMesInventoryComprehensiveBusinessDetail from "@/store/sithMes/inventory/SithMesInventoryComprehensiveBusinessDetailStore.js";
import sithMesInventoryComprehensiveBusinessVendorAndSithInfo from "@/store/sithMes/inventory/SithMesInventoryComprehensiveBusinessVendorAndSithInfoStore.js";


const genericEntities = [
    'sithMesInventoryAreaLoc',
    'sithMesInventoryReceiveErrorType',
    'sithMesInventoryStatus',
    'sithMesInventoryItem',
    'sithMesInventoryPackingBom',
    'sithMesInventoryPo',
    'sithMesInventoryAbnormalArrivalProcess',
    'sithMesInventoryDeliveryTask',
    'sithMesInventoryDeliveryMaterial',
    'sithMesInventoryPackage',
    'sithMesInventoryShipment',
    'sithMesInventoryPackageMaterial',
    'sithMesInventoryWmStock',
    'sithMesInventoryWmDefinition',
    'sithMesInventoryBinStatus',
    'sithMesInventoryStorageInput',
    'sithMesInventoryMaterialDispatching',
    'sithMesInventoryReplacementRepair',
    'sithMesInventoryCount',
    'sithMesInventoryChangeMaterialProject',
    'sithMesInventoryTransportApplication',
    'sithMesInventoryReceiptReturnRecord',
    'sithMesInventoryOutdoorProcess',
    'sithMesInventoryOutdoorProductDetail',
    'sithMesInventoryOutdoorProductCategory',
    'sithMesInventoryStockReturn',
    'sithMesInventoryStockMovement',
    'sithMesInventoryChangeProjectDetail',
    'sithMesInventoryManualStorageType',
    'sithMesInventoryManualMaterialType',
    'sithMesInventoryManualCheck',
    'sithMesInventoryManualInput',
    'sithMesInventoryManualOutput',
    'sithMesInventoryLiftCheck',
    'sithMesInventoryLiftRiggings',
    'sithMesInventoryComprehensiveBusinessRecord',
    'sithMesInventoryComprehensiveBusinessDetail',
    'sithMesInventoryComprehensiveBusinessVendorAndSithInfo',
]

const entities = {
    sithMesInventoryAreaLoc,
    sithMesInventoryReceiveErrorType,
    sithMesInventoryStatus,
    sithMesInventoryItem,
    sithMesInventoryPackingBom,
    sithMesInventoryPo,
    sithMesInventoryAbnormalArrivalProcess,
    sithMesInventoryDeliveryTask,
    sithMesInventoryDeliveryMaterial,
    sithMesInventoryPackage,
    sithMesInventoryShipment,
    sithMesInventoryPackageMaterial,
    sithMesInventoryWmStock,
    sithMesInventoryWmDefinition,
    sithMesInventoryBinStatus,
    sithMesInventoryStorageInput,
    sithMesInventoryMaterialDispatching,
    sithMesInventoryReplacementRepair,
    sithMesInventoryCount,
    sithMesInventoryChangeMaterialProject,
    sithMesInventoryTransportApplication,
    sithMesInventoryReceiptReturnRecord,
    sithMesInventoryOutdoorProcess,
    sithMesInventoryOutdoorProductDetail,
    sithMesInventoryOutdoorProductCategory,
    sithMesInventoryStockReturn,
    sithMesInventoryStockMovement,
    sithMesInventoryChangeProjectDetail,
    sithMesInventoryManualStorageType,
    sithMesInventoryManualMaterialType,
    sithMesInventoryManualCheck,
    sithMesInventoryManualInput,
    sithMesInventoryManualOutput,
    sithMesInventoryLiftCheck,
    sithMesInventoryLiftRiggings,
    sithMesInventoryComprehensiveBusinessRecord,
    sithMesInventoryComprehensiveBusinessDetail,
    sithMesInventoryComprehensiveBusinessVendorAndSithInfo
}

export {genericEntities}

export default entities